

// const formatDate = (dateString, hour=true) => {
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
//     const year = date.getFullYear();
//     const hours = (date.getHours()).toString().padStart(2, '0');
//     const minutes = (date.getMinutes()).toString().padStart(2, '0'); 

//     if(hour){
//       return `${day}-${month}-${year} ${hours}:${minutes}`;
//     }else{
//       return `${day}-${month}-${year}`;
//     }
//   }

//   export default formatDate

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();

  if (isToday) {
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;

      return `${hours}:${minutes} ${ampm}`;
  } else {
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
  }
};

export default formatDate;
